var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Виберіть опцію в меню ліворуч ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }